module.exports = __webpack_public_path__ + "static/media/Gloria-Macapagal-Arroyo_cropped.ab46a348.jpg";